var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1692,
    height: 601,
    viewBox: "0 0 1692 601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 100.281H95.1719V96.6797H92V95.3281H95.1719V92H96.6328V95.3281H99.7969V96.6797H96.6328V100.281Z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 200.281H95.1719V196.68H92V195.328H95.1719V192H96.6328V195.328H99.7969V196.68H96.6328V200.281Z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 300.281H95.1719V296.68H92V295.328H95.1719V292H96.6328V295.328H99.7969V296.68H96.6328V300.281Z",
    fill: "#EAEAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 400.281H95.1719V396.68H92V395.328H95.1719V392H96.6328V395.328H99.7969V396.68H96.6328V400.281Z",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 500.281H95.1719V496.68H92V495.328H95.1719V492H96.6328V495.328H99.7969V496.68H96.6328V500.281Z",
    fill: "#EAEAEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 100.281H195.172V96.6797H192V95.3281H195.172V92H196.633V95.3281H199.797V96.6797H196.633V100.281Z",
    fill: "#EAEAEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 200.281H195.172V196.68H192V195.328H195.172V192H196.633V195.328H199.797V196.68H196.633V200.281Z",
    fill: "#EAEAEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 300.281H195.172V296.68H192V295.328H195.172V292H196.633V295.328H199.797V296.68H196.633V300.281Z",
    fill: "#EAEAEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 400.281H195.172V396.68H192V395.328H195.172V392H196.633V395.328H199.797V396.68H196.633V400.281Z",
    fill: "#EAEAEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 500.281H195.172V496.68H192V495.328H195.172V492H196.633V495.328H199.797V496.68H196.633V500.281Z",
    fill: "#EAEAEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 100.281H295.172V96.6797H292V95.3281H295.172V92H296.633V95.3281H299.797V96.6797H296.633V100.281Z",
    fill: "#EAEAEA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 200.281H295.172V196.68H292V195.328H295.172V192H296.633V195.328H299.797V196.68H296.633V200.281Z",
    fill: "#EAEAEA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 300.281H295.172V296.68H292V295.328H295.172V292H296.633V295.328H299.797V296.68H296.633V300.281Z",
    fill: "#EAEAEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 400.281H295.172V396.68H292V395.328H295.172V392H296.633V395.328H299.797V396.68H296.633V400.281Z",
    fill: "#EAEAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 500.281H295.172V496.68H292V495.328H295.172V492H296.633V495.328H299.797V496.68H296.633V500.281Z",
    fill: "#EAEAEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 100.281H395.172V96.6797H392V95.3281H395.172V92H396.633V95.3281H399.797V96.6797H396.633V100.281Z",
    fill: "#EAEAEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 200.281H395.172V196.68H392V195.328H395.172V192H396.633V195.328H399.797V196.68H396.633V200.281Z",
    fill: "#EAEAEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 300.281H395.172V296.68H392V295.328H395.172V292H396.633V295.328H399.797V296.68H396.633V300.281Z",
    fill: "#EAEAEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 400.281H395.172V396.68H392V395.328H395.172V392H396.633V395.328H399.797V396.68H396.633V400.281Z",
    fill: "#EAEAEA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 500.281H395.172V496.68H392V495.328H395.172V492H396.633V495.328H399.797V496.68H396.633V500.281Z",
    fill: "#EAEAEA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 100.281H495.172V96.6797H492V95.3281H495.172V92H496.633V95.3281H499.797V96.6797H496.633V100.281Z",
    fill: "#EAEAEA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 200.281H495.172V196.68H492V195.328H495.172V192H496.633V195.328H499.797V196.68H496.633V200.281Z",
    fill: "#EAEAEA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 300.281H495.172V296.68H492V295.328H495.172V292H496.633V295.328H499.797V296.68H496.633V300.281Z",
    fill: "#EAEAEA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 400.281H495.172V396.68H492V395.328H495.172V392H496.633V395.328H499.797V396.68H496.633V400.281Z",
    fill: "#EAEAEA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 500.281H495.172V496.68H492V495.328H495.172V492H496.633V495.328H499.797V496.68H496.633V500.281Z",
    fill: "#EAEAEA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 100.281H595.172V96.6797H592V95.3281H595.172V92H596.633V95.3281H599.797V96.6797H596.633V100.281Z",
    fill: "#EAEAEA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 200.281H595.172V196.68H592V195.328H595.172V192H596.633V195.328H599.797V196.68H596.633V200.281Z",
    fill: "#EAEAEA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 300.281H595.172V296.68H592V295.328H595.172V292H596.633V295.328H599.797V296.68H596.633V300.281Z",
    fill: "#EAEAEA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 400.281H595.172V396.68H592V395.328H595.172V392H596.633V395.328H599.797V396.68H596.633V400.281Z",
    fill: "#EAEAEA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 500.281H595.172V496.68H592V495.328H595.172V492H596.633V495.328H599.797V496.68H596.633V500.281Z",
    fill: "#EAEAEA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 100.281H695.172V96.6797H692V95.3281H695.172V92H696.633V95.3281H699.797V96.6797H696.633V100.281Z",
    fill: "#EAEAEA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 200.281H695.172V196.68H692V195.328H695.172V192H696.633V195.328H699.797V196.68H696.633V200.281Z",
    fill: "#EAEAEA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 300.281H695.172V296.68H692V295.328H695.172V292H696.633V295.328H699.797V296.68H696.633V300.281Z",
    fill: "#EAEAEA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 400.281H695.172V396.68H692V395.328H695.172V392H696.633V395.328H699.797V396.68H696.633V400.281Z",
    fill: "#EAEAEA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 500.281H695.172V496.68H692V495.328H695.172V492H696.633V495.328H699.797V496.68H696.633V500.281Z",
    fill: "#EAEAEA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 100.281H795.172V96.6797H792V95.3281H795.172V92H796.633V95.3281H799.797V96.6797H796.633V100.281Z",
    fill: "#EAEAEA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 200.281H795.172V196.68H792V195.328H795.172V192H796.633V195.328H799.797V196.68H796.633V200.281Z",
    fill: "#EAEAEA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 300.281H795.172V296.68H792V295.328H795.172V292H796.633V295.328H799.797V296.68H796.633V300.281Z",
    fill: "#EAEAEA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 400.281H795.172V396.68H792V395.328H795.172V392H796.633V395.328H799.797V396.68H796.633V400.281Z",
    fill: "#EAEAEA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 500.281H795.172V496.68H792V495.328H795.172V492H796.633V495.328H799.797V496.68H796.633V500.281Z",
    fill: "#EAEAEA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 100.281H895.172V96.6797H892V95.3281H895.172V92H896.633V95.3281H899.797V96.6797H896.633V100.281Z",
    fill: "#EAEAEA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 200.281H895.172V196.68H892V195.328H895.172V192H896.633V195.328H899.797V196.68H896.633V200.281Z",
    fill: "#EAEAEA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 300.281H895.172V296.68H892V295.328H895.172V292H896.633V295.328H899.797V296.68H896.633V300.281Z",
    fill: "#EAEAEA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 400.281H895.172V396.68H892V395.328H895.172V392H896.633V395.328H899.797V396.68H896.633V400.281Z",
    fill: "#EAEAEA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 500.281H895.172V496.68H892V495.328H895.172V492H896.633V495.328H899.797V496.68H896.633V500.281Z",
    fill: "#EAEAEA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 100.281H995.172V96.6797H992V95.3281H995.172V92H996.633V95.3281H999.797V96.6797H996.633V100.281Z",
    fill: "#EAEAEA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 200.281H995.172V196.68H992V195.328H995.172V192H996.633V195.328H999.797V196.68H996.633V200.281Z",
    fill: "#EAEAEA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 300.281H995.172V296.68H992V295.328H995.172V292H996.633V295.328H999.797V296.68H996.633V300.281Z",
    fill: "#EAEAEA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 400.281H995.172V396.68H992V395.328H995.172V392H996.633V395.328H999.797V396.68H996.633V400.281Z",
    fill: "#EAEAEA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 500.281H995.172V496.68H992V495.328H995.172V492H996.633V495.328H999.797V496.68H996.633V500.281Z",
    fill: "#EAEAEA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 100.281H1095.17V96.6797H1092V95.3281H1095.17V92H1096.63V95.3281H1099.8V96.6797H1096.63V100.281Z",
    fill: "#EAEAEA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 200.281H1095.17V196.68H1092V195.328H1095.17V192H1096.63V195.328H1099.8V196.68H1096.63V200.281Z",
    fill: "#EAEAEA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 300.281H1095.17V296.68H1092V295.328H1095.17V292H1096.63V295.328H1099.8V296.68H1096.63V300.281Z",
    fill: "#EAEAEA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 400.281H1095.17V396.68H1092V395.328H1095.17V392H1096.63V395.328H1099.8V396.68H1096.63V400.281Z",
    fill: "#EAEAEA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 500.281H1095.17V496.68H1092V495.328H1095.17V492H1096.63V495.328H1099.8V496.68H1096.63V500.281Z",
    fill: "#EAEAEA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 100.281H1195.17V96.6797H1192V95.3281H1195.17V92H1196.63V95.3281H1199.8V96.6797H1196.63V100.281Z",
    fill: "#EAEAEA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 200.281H1195.17V196.68H1192V195.328H1195.17V192H1196.63V195.328H1199.8V196.68H1196.63V200.281Z",
    fill: "#EAEAEA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 300.281H1195.17V296.68H1192V295.328H1195.17V292H1196.63V295.328H1199.8V296.68H1196.63V300.281Z",
    fill: "#EAEAEA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 400.281H1195.17V396.68H1192V395.328H1195.17V392H1196.63V395.328H1199.8V396.68H1196.63V400.281Z",
    fill: "#EAEAEA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 500.281H1195.17V496.68H1192V495.328H1195.17V492H1196.63V495.328H1199.8V496.68H1196.63V500.281Z",
    fill: "#EAEAEA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 100.281H1295.17V96.6797H1292V95.3281H1295.17V92H1296.63V95.3281H1299.8V96.6797H1296.63V100.281Z",
    fill: "#EAEAEA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 200.281H1295.17V196.68H1292V195.328H1295.17V192H1296.63V195.328H1299.8V196.68H1296.63V200.281Z",
    fill: "#EAEAEA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 300.281H1295.17V296.68H1292V295.328H1295.17V292H1296.63V295.328H1299.8V296.68H1296.63V300.281Z",
    fill: "#EAEAEA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 400.281H1295.17V396.68H1292V395.328H1295.17V392H1296.63V395.328H1299.8V396.68H1296.63V400.281Z",
    fill: "#EAEAEA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 500.281H1295.17V496.68H1292V495.328H1295.17V492H1296.63V495.328H1299.8V496.68H1296.63V500.281Z",
    fill: "#EAEAEA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 100.281H1395.17V96.6797H1392V95.3281H1395.17V92H1396.63V95.3281H1399.8V96.6797H1396.63V100.281Z",
    fill: "#EAEAEA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 200.281H1395.17V196.68H1392V195.328H1395.17V192H1396.63V195.328H1399.8V196.68H1396.63V200.281Z",
    fill: "#EAEAEA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 300.281H1395.17V296.68H1392V295.328H1395.17V292H1396.63V295.328H1399.8V296.68H1396.63V300.281Z",
    fill: "#EAEAEA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 400.281H1395.17V396.68H1392V395.328H1395.17V392H1396.63V395.328H1399.8V396.68H1396.63V400.281Z",
    fill: "#EAEAEA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 500.281H1395.17V496.68H1392V495.328H1395.17V492H1396.63V495.328H1399.8V496.68H1396.63V500.281Z",
    fill: "#EAEAEA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 100.281H1495.17V96.6797H1492V95.3281H1495.17V92H1496.63V95.3281H1499.8V96.6797H1496.63V100.281Z",
    fill: "#EAEAEA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 200.281H1495.17V196.68H1492V195.328H1495.17V192H1496.63V195.328H1499.8V196.68H1496.63V200.281Z",
    fill: "#EAEAEA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 300.281H1495.17V296.68H1492V295.328H1495.17V292H1496.63V295.328H1499.8V296.68H1496.63V300.281Z",
    fill: "#EAEAEA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 400.281H1495.17V396.68H1492V395.328H1495.17V392H1496.63V395.328H1499.8V396.68H1496.63V400.281Z",
    fill: "#EAEAEA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 500.281H1495.17V496.68H1492V495.328H1495.17V492H1496.63V495.328H1499.8V496.68H1496.63V500.281Z",
    fill: "#EAEAEA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 100.281H1595.17V96.6797H1592V95.3281H1595.17V92H1596.63V95.3281H1599.8V96.6797H1596.63V100.281Z",
    fill: "#EAEAEA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 200.281H1595.17V196.68H1592V195.328H1595.17V192H1596.63V195.328H1599.8V196.68H1596.63V200.281Z",
    fill: "#EAEAEA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 300.281H1595.17V296.68H1592V295.328H1595.17V292H1596.63V295.328H1599.8V296.68H1596.63V300.281Z",
    fill: "#EAEAEA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 400.281H1595.17V396.68H1592V395.328H1595.17V392H1596.63V395.328H1599.8V396.68H1596.63V400.281Z",
    fill: "#EAEAEA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 500.281H1595.17V496.68H1592V495.328H1595.17V492H1596.63V495.328H1599.8V496.68H1596.63V500.281Z",
    fill: "#EAEAEA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6328 600.281H95.1719V596.68H92V595.328H95.1719V592H96.6328V595.328H99.7969V596.68H96.6328V600.281Z",
    fill: "#EAEAEA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M196.633 600.281H195.172V596.68H192V595.328H195.172V592H196.633V595.328H199.797V596.68H196.633V600.281Z",
    fill: "#EAEAEA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M296.633 600.281H295.172V596.68H292V595.328H295.172V592H296.633V595.328H299.797V596.68H296.633V600.281Z",
    fill: "#EAEAEA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M396.633 600.281H395.172V596.68H392V595.328H395.172V592H396.633V595.328H399.797V596.68H396.633V600.281Z",
    fill: "#EAEAEA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M496.633 600.281H495.172V596.68H492V595.328H495.172V592H496.633V595.328H499.797V596.68H496.633V600.281Z",
    fill: "#EAEAEA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M596.633 600.281H595.172V596.68H592V595.328H595.172V592H596.633V595.328H599.797V596.68H596.633V600.281Z",
    fill: "#EAEAEA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M696.633 600.281H695.172V596.68H692V595.328H695.172V592H696.633V595.328H699.797V596.68H696.633V600.281Z",
    fill: "#EAEAEA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M796.633 600.281H795.172V596.68H792V595.328H795.172V592H796.633V595.328H799.797V596.68H796.633V600.281Z",
    fill: "#EAEAEA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M896.633 600.281H895.172V596.68H892V595.328H895.172V592H896.633V595.328H899.797V596.68H896.633V600.281Z",
    fill: "#EAEAEA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M996.633 600.281H995.172V596.68H992V595.328H995.172V592H996.633V595.328H999.797V596.68H996.633V600.281Z",
    fill: "#EAEAEA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.63 600.281H10 95.17V596.68H1092V595.328H1095.17V592H1096.63V595.328H1099.8V596.68H1096.63V600.281Z",
    fill: "#EAEAEA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.63 600.281H1195.17V596.68H1192V595.328H1195.17V592H1196.63V595.328H1199.8V596.68H1196.63V600.281Z",
    fill: "#EAEAEA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.63 600.281H1295.17V596.68H1292V595.328H1295.17V592H1296.63V595.328H1299.8V596.68H1296.63V600.281Z",
    fill: "#EAEAEA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.63 600.281H1395.17V596.68H1392V595.328H1395.17V592H1396.63V595.328H1399.8V596.68H1396.63V600.281Z",
    fill: "#EAEAEA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1496.63 600.281H1495.17V596.68H1492V595.328H1495.17V592H1496.63V595.328H1499.8V596.68H1496.63V600.281Z",
    fill: "#EAEAEA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1596.63 600.281H1595.17V596.68H1592V595.328H1595.17V592H1596.63V595.328H1599.8V596.68H1596.63V600.281Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBackground);
export default __webpack_public_path__ + "static/media/plus-background.62db4e4a872ec16daaf7528fb30266f5.svg";
export { ForwardRef as ReactComponent };